import { Link, useNavigate } from 'react-router-dom';
import styles from './index.module.sass';
import LogoSvg from '@@/buyer-account/images/logo.svg';
import classNames from 'classnames';
import { Dropdown } from 'antd';
import { $userData, logout } from '@/modules/auth/store/auth.store';
import { DiContainer } from '@/modules/di/di-container';
import { AuthService } from '@/modules/auth/services/auth.service';
import { useStore } from 'effector-react';
const authService = DiContainer.get(AuthService);

export const Nav = ({
  items,
}: {
  items: { label: string; to: string; active: boolean }[];
}) => {
  const user = useStore($userData);
  const navigate = useNavigate();
  const menuIems = [
    { key: 0, label: <span className={styles.menuItem}>Редактировать профиль</span> },
    {
      key: 1,
      label: <span style={{ color: '#E73A42', fontWeight: 600 }}>Выйти</span>,
    },
  ];
  return (
    <div className={styles.root}>
      <div className={styles.logoArea}>
        <img alt="logo" src={LogoSvg} onClick={() => navigate('/')} />
      </div>
      <div className={styles.navArea}>
        {items.map((item, i) => (
          <Link
            key={i}
            className={classNames(styles.navLink, item.active && styles.active)}
            to={item.to || '/'}
          >
            {item.label}
          </Link>
        ))}
      </div>

      <div className={styles.statusArea}>
        <Dropdown
          placement="bottomLeft"
          menu={{
            items: menuIems,
            onClick: async ({ key }) => {
              if (key === '0') {
                return navigate('/buyer-settings');
              }
              if (key === '1') {
                logout();
                await authService.logout();
                navigate('/');
                return;
              }
            },
          }}
        >
          <div>
            <span className={styles.profileLabel}>{user?.company?.name}</span>
          </div>
        </Dropdown>
        <div className={styles.statusIndicator}></div>
        {/* <div className={styles.contextDropdown}>

                    </div> */}
      </div>
    </div>
  );
};
